module.exports = __webpack_public_path__ + "23a32c581ce07de1dc36dd5eb6675354.png";